import axios from 'axios';
import configSingletonInstance from 'src/ConfigSingleton';

const instance = axios.create({
  withCredentials: true
});

instance.interceptors.request.use(config => {
  config.baseURL = configSingletonInstance.getConfig()?.apiHost;
  const urlPath = config.url.startsWith('/')
    ? config.url.substring(1)
    : config.url;

  const tokenLessPaths =
    configSingletonInstance.getConfig()?.TOKEN_LESS_PATH || [];
  if (urlPath && tokenLessPaths.includes(urlPath.split('?')[0])) {
    config.headers.Authorization = '';
  }

  return config;
});

export default instance;
